import { ETabs } from 'reactApp/sections/QuotaLanding/QuotaLanding.data';

enum ETabName {
    quota = 'Хранилище',
    features = 'Преимущества',
    tariffs = 'Тарифы',
    questions = 'Вопросы',
    cleaner = 'Управление',
    apps = 'Приложения',
    feedback = 'Обратная связь',
    help = 'Помощь',
}

interface Tab {
    id: ETabs;
    isCurrent: boolean;
    text: string;
}

export const getTabs = (currentTab, filterTabs: (tab: ETabs) => boolean, isTariffTabMajor: boolean): Tab[] => {
    const tabsWithTariffMajor = [ETabs.quota, ETabs.cleaner, ETabs.tariffs, ETabs.features, ETabs.questions];
    const defaultTabs = [ETabs.quota, ETabs.cleaner, ETabs.features, ETabs.tariffs, ETabs.questions];
    const tabs = isTariffTabMajor ? tabsWithTariffMajor : defaultTabs;

    return tabs.filter(filterTabs).map((tab) => ({ id: tab, isCurrent: tab === currentTab, text: ETabName[tab] }));
};

export const getMobileTabs = (currentTab, filterTabs: (tab: ETabs) => boolean): Tab[] => {
    const tabs = [ETabs.quota, ETabs.features, ETabs.tariffs, ETabs.questions, ETabs.apps, ETabs.feedback, ETabs.help].filter(filterTabs);

    return tabs.map((tab) => ({ id: tab, isCurrent: tab === currentTab, text: ETabName[tab] }));
};

export const getTabsChecker = (config) => (tab: ETabs) => !config[tab];
